import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { PAY_URL } from "../../../BaseURL";
import toast from "react-hot-toast";

export const getUserAdminShift = createAsyncThunk('/shift/getUserAdminShift',
    async () => {
        try {
            const myurl = `${PAY_URL}/user/get-admin-shift`;

            const response = await axios({
                method: 'get',
                url: myurl,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem('PAY_USER_TOKEN')
                },
            });

            const groupData = response.data;
            // console.log(groupData, "getUserAdminShift response");

            if (groupData.success === true) {
                return groupData;
            } else {
                throw new Error(groupData.message);
            }
        } catch (error) {
            console.log(error, "error");
            toast.error(error.response.data.message);
            return error
        }
    })

const getUserAdminShiftSlice = createSlice({
    name: "getUserAdminShift",
    initialState: {
        user: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getUserAdminShift.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getUserAdminShift.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(getUserAdminShift.rejected, (state, action) => {
                state.user = null;
                state.loading = false;
                state.error = action.error.message;
            });
    }
})

export default getUserAdminShiftSlice.reducer;